export default {
  name: 'proxyviews-seo',

  initialize() {},
};
